import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { UiService } from "app/helper-components/UiService";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { NewEventService } from "app/main/events/event-form/event-form.service";
import { UripinarComponent } from "app/main/uripinar/uripinar.component";
import { environment } from "environments/environment";
import moment from "moment";

@Component({
  selector: "app-add-vacancies",
  templateUrl: "./add-vacancies.component.html",
  styleUrls: ["./add-vacancies.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AddVacanciesComponent implements OnInit {
  _name: string;
  member_name: string;
  member_id: string;
  member_image: any;
  @Output() nameChange = new EventEmitter();
  parameters: any;
  specifications: string = "";
  open_date: string;
  close_date: string;
  decision_date: string;
  Open_date: any = "";
  Close_date: any = "";
  Decision_date: any = "";
  minDate_Close_Date: any = "";
  minDate_Decision_Date: any = "";
  minDate = moment(new Date()).format("YYYY-MM-DD");
  myInput: any;
  list = false;
  showMore = false;
  uripinarList: any = [];
  page: any = 0;
  const_id: any = 0;
  isWait: boolean = false;
  organisers: any[];

  form = new FormGroup({
    specifications: new FormControl("", Validators.required),
    open_date: new FormControl("", Validators.required),
    // close_date: new FormControl("", Validators.required),
    // decision_date: new FormControl("", Validators.required),
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private httpClient: HttpClient,
    private postService: PostService,
    private translateService: TranslateService,
    private snackBar: MatSnackBar,
    private uiService: UiService,
    private _newEventService: NewEventService,
    private cdr: ChangeDetectorRef,
    private _uiService: UiService,

    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<UripinarComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    // public matDialogRef: MatDialogRef<AddVacanciesComponent>,
    public dialogRef: MatDialogRef<FuseConfirmDialogComponent>
  ) {
    // this.const_id = this.data.parameters.const_id;
  }

  ngOnInit(): void {
    // console.log(this._data);

    //  var data = this.helper.getPlaceIdAndGroupId(this.parameters);
    // console.log(data);
    if (this._data.types == "add") {
      this.member_name = this._data.member_data.name;
      var member_name = this.member_name;
      this.member_id = this._data.member_data.member_id;
      var member_id = this.member_id;
      this.member_image = this._data.member_data.photo_url;
      var member_image = this.member_image;
    }

    if (this.data.types == "edit") {
      this.specifications = this.data.VaccancyData.specifications;
      this.open_date = moment(this.data.VaccancyData.open_date).format(
        "YYYY-MM-DD"
      );
      this.close_date = moment(this.data.VaccancyData.close_date).format(
        "YYYY-MM-DD"
      );
      this.decision_date = moment(this.data.VaccancyData.decision_date).format(
        "YYYY-MM-DD"
      );
      this.form.controls["specifications"].setValue(this.specifications);
      this.form.controls["open_date"].setValue(this.open_date);
      // this.form.controls["close_date"].setValue(this.close_date);
      this.form.controls["decision_date"].setValue(this.decision_date);
    }
  }

  onClickOpenDate(event) {
    this.Open_date = event.value;
    this.minDate_Decision_Date = moment(this.Open_date).format("YYYY-MM-DD");
  }

  // onClickCloseDate(event) {
  //   this.Close_date = event.value;
  //   this.minDate_Decision_Date = moment(this.Close_date).format("YYYY-MM-DD");
  // }

  trackByFn(index, item) {
    return index; // or item.id
  }

  errorHandler(event) {
    event.target.src = "/assets/images/empty_profile_male.jpg";
  }

  OnInput(value, seeMore = false) {
    if (!seeMore) {
      this.uripinarList = [];
    }
    if (value.length > 2) {
      this.isWait = false;
      const formData = new FormData();
      if (
        this.data.parameters.hasOwnProperty("event_level") &&
        this.data.parameters.event_level == "country"
      ) {
        formData.append("searchMember", "1");
        formData.append("input", value);
        formData.append("page", this.page);
      } else {
        formData.append("searchMemberInConstituency", "1");
        formData.append("input", value);
        formData.append("page", this.page);
        formData.append("const_id", this.const_id);
      }

      this.postService
        .post(environment.API_MEMBER, formData)
        .subscribe((val) => {
          this.isWait = false;
          this.list = true;
          this.showMore = val.data.length / val.limit > 1;
          if (val.limit * val.page > val.total_count) {
            this.showMore = false;
          }
          this.uripinarList = [...this.uripinarList, ...val.data];
        });
    } else {
      this.list = false;
    }
  }

  showEmptyProfile(event) {
    event.target.src = "/assets/images/empty_profile_male.jpg";
  }

  getUripinar(uripinar: any) {
    var selectedUripinar = uripinar;
    this.dialogRef.close({ data: selectedUripinar });
  }

  seeMore(value) {
    this.page += 1;
    this.OnInput(value, true);
  }

  searchClick(value) {
    this.isWait = true;
    this.list = false;
    this.showMore = false;
    this.uripinarList = [];
    const formData = new FormData();
    formData.append("searchMember", "1");
    formData.append("member_id", value);

    this.postService.post(environment.API_MEMBER, formData).subscribe((val) => {
      this.isWait = false;
      this.list = true;
      this.showMore = false;
      if (val.status == "success") {
        this.uripinarList = [val.data];
      }
    });
  }

  //   addOrganiser(memberData: any, type){
  //     let request: any = {};

  //     // request.event_id = this.event.event_id;
  //     request.member_id = memberData.member_id;
  //     request.type = type;
  //     request.party_post_id = this.parameters.party_post_id;
  //     this._uiService.showLoading();
  //     this._newEventService.addOrganizers(request).subscribe((val) => {
  //   if (!this.organisers) {
  //     this.organisers = [];
  //   }
  //   // console.log(val);
  //   this.organisers.push({
  //     additionalInfo: null,
  //     event_organiser_id: val.id,
  //     member_id: memberData.member_id,
  //     name: memberData.name,
  //     participant_type: type,
  //     photo_url: memberData.photo_url,
  //   });
  //   // console.log(this.organisers);
  //   this.cdr.detectChanges();
  // });
  //   }

  onSubmit() {
    if (this.data.types == "add") {
      var myJson: any = this.form.value;
      const formData = new FormData();

      if (this.form.value.specifications == undefined) {
        myJson.specifications = null;
      }
      myJson.start_date = moment(this.form.value.open_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      // myJson.expiry_date = moment(this.form.value.close_date).format(
      //   "YYYY-MM-DD HH:mm:ss"
      // );
      // myJson.decision_date = moment(this.form.value.decision_date).format("YYYY-MM-DD HH:mm:ss")
      // myJson.group_id = this.data.parameters.party_post_group_id;
      myJson.party_post_subgroup_id =
        this.data.PartyPostData.party_post_subgroup_id;
      myJson.barrack_id = this.data.PartyPostData.barrack_id;
      myJson.member_id = this.data.member_data.member_id;
      // myJson.member_name = this.data.member_data.name;
      myJson.party_post_place_id = this.data.parameters.place_id;
      myJson.party_post_id = this.data.parameters.party_post_id;

      formData.append(
        "start_date",
        moment(this.form.value.open_date).format("YYYY-MM-DD HH:mm:ss")
      );
      // formData.append(
      //   "expiry_date",
      //   moment(this.form.value.close_date).format("YYYY-MM-DD HH:mm:ss")
      // );
      formData.append(
        "party_post_subgroup_id",
        this.data.PartyPostData.party_post_subgroup_id
      );
      formData.append("member_id", this.data.member_data.member_id);
      formData.append("barrack_id", this.data.PartyPostData.barrack_id);
      formData.append("party_post_place_id", this.data.parameters.place_id);
      formData.append("party_post_id", this.data.parameters.party_post_id);

      this.uiService.showLoading();
      // console.log(myJson);
      this.httpClient
        .post(environment.ADD_PARTYPOST_VACCANCIES, formData)
        .subscribe((data: any) => {
          // this.httpClient.post(environment.ADD_PARTYPOST_VACCANCIES, myJson).subscribe((data: any) => {
          if (data.status == "success") {
            this.translateService
              .get("கட்சி பதவி காலியிடம் வெற்றிகரமாக சேர்க்கப்பட்டது...")
              .subscribe((val) => {
                this.snackBar.open(val, "Close!", {
                  panelClass: "snack-success",
                  duration: 5000,
                });
              });
            this.matDialogRef.close(data);
            this.uiService.hideLoading();
          } else {
            this.translateService
              .get("காலியிடத்தைச் சேர்ப்பதில் பிழை...")
              .subscribe((val) => {
                this.snackBar.open(data.message, "Close!", {
                  panelClass: "snack-danger",
                  duration: 5000,
                });
              });
            this.uiService.hideLoading();
            this.matDialogRef.close(data);
          }
        });
    } else {
      var myJson: any = {};
      if (this.form.value.specifications == null) {
        myJson.specifications = null;
      } else {
        myJson.specifications = this.form.value.specifications;
      }
      myJson.id = this.data.VaccancyData.id;
      myJson.start_date = moment(this.form.value.open_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      // myJson.expiry_date = moment(this.form.value.close_date).format(
      //   "YYYY-MM-DD HH:mm:ss"
      // );
      // myJson.decision_date = moment(this.form.value.decision_date).format("YYYY-MM-DD HH:mm:ss")
      // myJson.group_id = this.data.parameters.party_post_group_id;
      myJson.party_post_subgroup_id =
        this.data.PartyPostData.party_post_subgroup_id;
      myJson.barrack_id = this.data.PartyPostData.barrack_id;
      myJson.member_id = this.data.member_data.member_id;
      // myJson.member_name = this.data.member_data.name;
      myJson.party_post_place_id = this.data.parameters.place_id;
      myJson.party_post_id = this.data.parameters.party_post_id;

      this.uiService.showLoading();
      this.httpClient
        .patch(environment.UPDATE_PARTY_POST_VACANCY, myJson)
        .subscribe((data: any) => {
          if (data.status == "success") {
            this.translateService
              .get("Vacancy Updated Successfully")
              .subscribe((val) => {
                this.snackBar.open(val, "Close!", {
                  panelClass: "snack-success",
                  duration: 5000,
                });
              });
            this.matDialogRef.close(data);
            this.uiService.hideLoading();
          }
        });
    }
  }
}
